import {useFilterMenuContext} from 'src/app/components'
import { luckyDrawParticipantStatuses } from 'src/app/components/Feedback/FilterMenu/FilterMenuContent.templates'
import {useUrlSearchParams} from 'src/app/hooks'
import { FilterMenuContentParticipantProps } from './FilterMenuContentParticipant'
import { DateObject } from 'react-multi-date-picker'
import { convertPeriod } from 'src/app/components/Feedback/FilterMenu/FilterMenuContent.utils'

export function useFilterMenuContentParticipantHook() {

  const [searchParams] = useUrlSearchParams<'status' | 'time' | 'start_date' | 'end_date'>()
  const defaultFilter = {
    status: searchParams.status,
    time: searchParams.time,
    start_date: searchParams.start_date,
    end_date: searchParams.end_date
  }

  const filterContext = useFilterMenuContext<typeof searchParams>({defaultValues: defaultFilter})

  const getStatusMaster = (params: FilterMenuContentParticipantProps) => {
    return luckyDrawParticipantStatuses.filter((item) => {
      if (item.value === 'SUSPEND') {
        return params.withStatusSuspended
      }
      if (item.value === 'DELETED') {
        return params.withStatusDeleted
      }
      if (item.value === 'ACTIVE') {
        return params.withStatusActive
      }
      return true
    })
  }

  const handleChangeStartTime= (value: DateObject | DateObject[] | null) => {
    filterContext.updateDraft({start_date: convertPeriod(value)})
  }
  const handleChangeEndTime= (value: DateObject | DateObject[] | null) => {
    filterContext.updateDraft({end_date: convertPeriod(value)})
  }
  return ({
    filterContext,
    action: {
      handleChangeStartTime,
      handleChangeEndTime
    },
    master: {
      getStatusMaster,
      luckyDrawParticipantStatuses,
    },
  })
}
